import { ChangeDetectionStrategy, Component } from '@angular/core';
import {TextPageComponent} from "../../../components/text-page/text-page.component";
import {PageTitleLayoutComponent} from "../../../components/page-title-layout/page-title-layout.component";
import {PageSubtitleComponent} from "../../../components/page-subtitle/page-subtitle.component";
import {ParagraphsComponent} from "../../../components/paragraphs/paragraphs.component";
import {
    LotteriesAndFooterComponent
} from "../../../components/lotteries-and-footer/lotteries-and-footer.component";

@Component({
  selector: 'homey-your-data-page',
    imports: [
        TextPageComponent,
        PageTitleLayoutComponent,
        PageSubtitleComponent,
        ParagraphsComponent,
        LotteriesAndFooterComponent
    ],
  templateUrl: './your-data-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class YourDataPageComponent {

}
